import { Auth } from 'aws-amplify';
import awsConfig from '../aws-exports';

export interface PlayFactoryRequest {
	contentType: string;
	contentSelector: string;
	contentId: string;
}

export interface DeliveryEndpoint {
	url: string;
	cdn: string;
}

export interface VideoData {
	deliveryEndpoints: DeliveryEndpoint[];
	licenseAcquisitionUrl: string;
	expirations: {
		deliveryEndpoints: string;
		licenseAcquisitionUrl: string;
	};
}

export const fetchPlayFactoryVideo = async (
	contentId: string,
	contentType: string = 'EVENT',
	contentSelector: string = 'EME-CENC-HLS'
): Promise<VideoData> => {
	try {
		const currentSession = await Auth.currentSession();
		const jwtToken = currentSession.getIdToken().getJwtToken();

		const proxyUrl = `${awsConfig.licenseAcquisitionEndpointUrl}/play-factory/play-privileged`;

		const requestBody: PlayFactoryRequest = {
			contentType,
			contentSelector,
			contentId
		};

		const response = await fetch(proxyUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${jwtToken}`
			},
			body: JSON.stringify(requestBody)
		});

		if (!response.ok) {
			const errorText = await response.text();
			throw new Error(`Play Factory API error: ${response.status} - ${errorText}`);
		}

		const data: VideoData = await response.json();
		return data;
	} catch (error) {
		console.error('Error fetching from Play Factory:', error);
		throw error;
	}
};


export const isPlayFactoryAvailable = (): boolean => {
	return !!awsConfig.licenseAcquisitionEndpointUrl;
};
